module.exports = __webpack_public_path__ + "img/flndex03.e585bb05.png";